import React, { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import { authFetch } from "../../lib/api"

export default function SavedSearches() {
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState("")

  const load = () => {
    setError("")
    authFetch("/api/saved-searches")
      .then((r) => r.json())
      .then((data) => {
        if (data.error) setError(data.error)
        else setList(data.savedSearches || [])
      })
      .catch(() => setError("Failed to load saved searches"))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    load()
  }, [])

  const buildListingsQuery = (params) => {
    const p = params || {}
    const q = new URLSearchParams()
    if (p.location) q.set("location", p.location)
    if (p.type) q.set("type", p.type)
    if (p.category) q.set("category", p.category)
    if (p.priceMin != null) q.set("priceMin", p.priceMin)
    if (p.priceMax != null) q.set("priceMax", p.priceMax)
    const s = q.toString()
    return s ? `/listings?${s}` : "/listings"
  }

  const handleDelete = async (id) => {
    if (!window.confirm("Remove this saved search?")) return
    const res = await authFetch(`/api/saved-searches/${id}`, { method: "DELETE" })
    if (res.ok) setList((prev) => prev.filter((item) => item.id !== id))
  }

  const describeSearch = (params = {}) => {
    const pieces = [params.location, params.type, params.category].filter(Boolean)
    return pieces.length ? pieces.join(" / ") : "No filters"
  }

  return (
    <section className='dashboard-card'>
      <div className='dashboard-card__header'>
        <div>
          <span className='dashboard-eyebrow'>Search shortcuts</span>
          <h2>Saved searches</h2>
          <p>Open your saved criteria in Listings with filters already applied.</p>
        </div>
        <Link to='/listings' className='dashboard-primary-action'>
          <i className='fa-solid fa-magnifying-glass'></i>
          New search
        </Link>
      </div>

      {error && <p className='dashboard-error'>{error}</p>}
      {loading ? (
        <p>Loading...</p>
      ) : list.length === 0 ? (
        <div className='dashboard-empty'>
          No saved searches yet. Save a search from the Listings page and it will appear here.
        </div>
      ) : (
        <ul className='dashboard-list'>
          {list.map((item) => (
            <li key={item.id} className='dashboard-list__row'>
              <div>
                <strong>{describeSearch(item.params)}</strong>
                {(item.params.priceMin != null || item.params.priceMax != null) && (
                  <div className='dashboard-list__meta'>
                    Price: {item.params.priceMin ?? "Any"} - {item.params.priceMax ?? "Any"}
                  </div>
                )}
              </div>
              <div className='dashboard-list__actions'>
                <Link to={buildListingsQuery(item.params)} className='btn btn--secondary'>
                  Open in Listings
                </Link>
                <button type='button' className='btn btn--danger' onClick={() => handleDelete(item.id)}>
                  Remove
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </section>
  )
}
